var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEnterprise = function SvgIconEnterprise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.232 1h7.536l3.346 5.02L8 15.323.886 6.02zm.536 1L2.114 5.98 8 13.677l5.886-7.697L11.232 2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.655 4.5h2.69l1.27 1.905L8 9.823 5.386 6.405zm.536 1-.577.865L8 8.177l1.386-1.812-.577-.865z",
    clipRule: "evenodd"
  })));
};
export { SvgIconEnterprise as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjIzMjM2IDFIMTEuNzY3NUwxNS4xMTQyIDYuMDE5OTJMNy45OTk5NSAxNS4zMjMxTDAuODg1NzQyIDYuMDE5OTJMNC4yMzIzNiAxWk00Ljc2NzU0IDJMMi4xMTQxNSA1Ljk4MDA4TDcuOTk5OTUgMTMuNjc2OUwxMy44ODU3IDUuOTgwMDhMMTEuMjMyNCAySDQuNzY3NTRaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjY1NTQzIDQuNUg5LjM0NDQ2TDEwLjYxNDIgNi40MDQ1NEw3Ljk5OTk1IDkuODIzMTFMNS4zODU3NCA2LjQwNDU0TDYuNjU1NDMgNC41Wk03LjE5MDYyIDUuNUw2LjYxNDE1IDYuMzY0NjlMNy45OTk5NSA4LjE3Njg5TDkuMzg1NzQgNi4zNjQ2OUw4LjgwOTI4IDUuNUg3LjE5MDYyWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";